import 'css-chunksrc/client/scenes/documentCreation/form/folderSelection/styles.scss';export default {
  "input": "_input_11tt2_1",
  "placeholder": "_placeholder_11tt2_15",
  "icon": "_icon_11tt2_22",
  "listRoot": "_listRoot_11tt2_28",
  "list": "_list_11tt2_28",
  "opened": "_opened_11tt2_45",
  "project": "_project_11tt2_54",
  "projectIcon": "_projectIcon_11tt2_65"
};